module.exports = __webpack_public_path__ + "media/images/flags/16/Mauritania-3ac58effc84dcc6c8e850ac5adf9d977.png";